import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('private_exchange', '/private_exchanges')
const reducer = generator.generate()

export default reducer
